export default __webpack_public_path__ + "static/media/BusinessConsultingLebenswerkBusinessManagement2.4ada4e10.png";